export default __webpack_public_path__ + "static/media/3.b359d8e8.jpg";